import React from 'react';
import permissionConstants, { detailPermission } from './constants/permission.constans';
import routeConstant, {
  forgotPassRoute,
  userManagementRoute,
  emailNotiRoute,
} from './constants/route.constants';

const LoginPage = React.lazy(() => import('./container/login-page'));
const NotFound = React.lazy(() => import('./container/not-found'));
const DashBoard = React.lazy(() => import('./container/views/dashboard'));
const Guide = React.lazy(() => import('./container/views/guide'));
const PrivacyStatement = React.lazy(() => import('./layouts/global-footer/PrivacyStatementModal'));
const Introduction = React.lazy(() => import('./layouts/global-footer/IntroModal'));
const TermOfUse = React.lazy(() => import('./layouts/global-footer/TermOfUseModal'));
const Contact = React.lazy(() => import('./layouts/global-footer/ContactModal'));
const FamilyTree = React.lazy(() => import('./components/familytree'));
const UserManagement = React.lazy(() => import('./container/views/user-management'));
const UserDetail = React.lazy(() =>
  import('./container/views/user-management/user-list/user-detail'),
);

const UserNameForgotPassword = React.lazy(() =>
  import('./container/ForgotPassword/enter-username'),
);
const ChangePassword = React.lazy(() => import('./container/ForgotPassword/change-password'));
const ChangePasswordSuccesfully = React.lazy(() =>
  import('./container/ForgotPassword/change-password-success'),
);
// const CvpManagement = React.lazy(() => import('./container/views/cvp-management'));
// const CreateCvp = React.lazy(() =>
//   import('./container/views/cvp-management/cvp-actions/create-cvp'),
// );
// const EditCvp = React.lazy(() => import('./container/views/cvp-management/cvp-actions/edit-cvp'));
const EmailNotification = React.lazy(() => import('./container/views/email-notification'));
const NotiDetail = React.lazy(() =>
  import('./container/views/email-notification/notification-template/notification-detail'),
);
// const PiaTC = React.lazy(() => import('./container/views/pia-tc/index'));
// const UpdateTC = React.lazy(() => import('./container/views/pia-tc/update-tc'));
const UnAuthorized = React.lazy(() => import('./container/unauthorized'));

const routes = [
  {
    path: routeConstant.DASH_BOARD,
    isFullPage: false,
    isPrivate: false,
    component: DashBoard,
  },
  {
    path: routeConstant.GUIDE,
    isFullPage: false,
    isPrivate: false,
    component: Guide,
  },
  {
    path: routeConstant.PRIVACY_STATEMENT,
    isFullPage: false,
    isPrivate: false,
    component: PrivacyStatement,
  },
  {
    path: routeConstant.CONTACT,
    isFullPage: false,
    isPrivate: false,
    component: Contact,
  },
  {
    path: routeConstant.INTRODUCTION,
    isFullPage: false,
    isPrivate: false,
    component: Introduction,
  },
  {
    path: routeConstant.TERM_OF_USE,
    isFullPage: false,
    isPrivate: false,
    component: TermOfUse,
  },
  {
    path: routeConstant.LOGIN,
    isFullPage: true,
    isPrivate: false,
    component: LoginPage,
  },
  {
    path: routeConstant.FULL_TREE,
    isFullPage: true,
    isPrivate: false,
    component: FamilyTree,
  },
  {
    path: routeConstant.USER_MANAGEMENT,
    isFullPage: false,
    isPrivate: true,
    component: UserManagement,
    exact: true,
    permissions: [permissionConstants.USERS_MANAGEMENT],
  },
  {
    path: routeConstant.USER_MANAGEMENT + userManagementRoute.DETAIL,
    isFullPage: false,
    isPrivate: true,
    component: UserDetail,
    permissions: [detailPermission.VIEW_LIST_OF_USER, detailPermission.VIEW_DETAIL_OF_USER],
  },
  {
    path: routeConstant.NOTFOUND,
    isFullPage: true,
    isPrivate: false,
    component: NotFound,
  },
  {
    path: forgotPassRoute.USER_NAME_FORGOT_PASS,
    isFullPage: true,
    isPrivate: false,
    component: UserNameForgotPassword,
  },
  {
    path: forgotPassRoute.CHANGE_PASS,
    isFullPage: true,
    isPrivate: false,
    component: ChangePassword,
  },
  {
    path: forgotPassRoute.CHANGE_PASS_SUCESS,
    isFullPage: true,
    isPrivate: false,
    component: ChangePasswordSuccesfully,
  },
  {
    path: routeConstant.UNAUTHORIZED,
    isFullPage: true,
    isPrivate: false,
    component: UnAuthorized,
  },
  {
    path: routeConstant.EMAIL_NOTIFICATION,
    isFullPage: false,
    isPrivate: true,
    component: EmailNotification,
    exact: true,
    permissions: [permissionConstants.EMAIL_TEMPLATE, permissionConstants.EMAIL_NOTIFICATION],
  },
  {
    path: routeConstant.EMAIL_NOTIFICATION + emailNotiRoute.DETAIL,
    isFullPage: false,
    isPrivate: true,
    component: NotiDetail,
    // Missing permission update template
    permissions: [permissionConstants.EMAIL_NOTIFICATION],
  },
];
export default routes;
